module.exports = __webpack_public_path__ + "img/img_process_con3.55d821ae.png";